import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useCallback, useContext } from 'react';

import { deleteFirm } from 'api/hs/definitions/firm-definitions/firms';
import DeleteDialogIcon from 'Common/DeleteDialogIcon';
import IndicatorWrapper from 'Common/IndicatorWrapper';
import { DialogContext } from 'context/dialog.context';

import { AlertContext } from '../../../../../context/alert.context';
import { FirmsContext } from '../../firm.context';
import EditDialog from './EditDialog';

export default function ListFirms() {
  const { loading, firms, setEditDialogOpened, setSelectedData, reload } = useContext(FirmsContext);
  const { openWarnDialog } = useContext(DialogContext);
  const { showMessage } = useContext(AlertContext);

  const openEditDialog = useCallback(
    data => {
      setSelectedData(data);
      setEditDialogOpened(true);
    },
    [setEditDialogOpened, setSelectedData]
  );

  const openDeleteDialog = useCallback(
    async data => {
      const submitted = await openWarnDialog({
        text: `${data?.firmName} - isimli firmayı silmek istediğinize emin misiniz ?`,
        Icon: <DeleteDialogIcon />,
      });
      try {
        if (submitted) {
          await deleteFirm(data.id);
          showMessage('Silme işlemi başarılı.', 'success', 'info');
          reload();
        }
      } catch (e) {
        showMessage('Silme işleminde sorun oluştu.', 'error', 'info');
      }
    },
    [reload, openWarnDialog, showMessage]
  );

  return (
    <div className="m-2">
      <IndicatorWrapper loading={loading} data={firms} errorMessage="Gösterilecek  Firma Bulunamadı">
        <TableContainer>
          <Table size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="text-bold" width="5%" align="left" />
                <TableCell style={{ color: 'gray' }} className="text-bold" width="35%" align="left">
                  Firma Adı
                </TableCell>
                <TableCell style={{ color: 'gray' }} className="text-bold" width="15%" align="left">
                  Firma Kodu
                </TableCell>
                <TableCell style={{ color: 'gray' }} className="text-bold" width="45%" align="right">
                  İşlem
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {firms.map(item => (
                <TableRow key={item.id}>
                  <TableCell align="left">
                    <AccountBalanceIcon style={{ color: 'gray' }} />
                  </TableCell>
                  <TableCell align="left">{item.firmName}</TableCell>
                  <TableCell align="left">{item.firmCode}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={() => openEditDialog(item)} edge="end" aria-label="edit">
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => openDeleteDialog(item)} edge="end" aria-label="delete">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <EditDialog />
      </IndicatorWrapper>
    </div>
  );
}
